<template>
    <v-sheet class="d-flex flex-column" style="flex: 1 0 auto">
        <v-row class="ma-0" align="center" :class="{ 'mb-n10 mb-md-n16': hideDivider }">
            <v-col cols="12" md="auto" style="width: 170px" v-bind="{ ...($attrs?.headerProps || {}), ...($attrs?.props?.headerProps || {}) }" class="vertical-table__tit pa-10 px-md-20 py-md-16 page-text font-weight-medium mb-n14 mb-md-0"> {{ term }} <span v-if="required" class="secondary--text">(필수)</span> </v-col>
            <v-col class="vertical-table__contents pa-10 px-md-20 py-md-16 page-text grey-6--text" style="white-space: pre-line;">
                <slot />
                <template v-if="message">
                    <p class="font-size-14 grey--text text--lighten-2 mt-4">
                        {{ message }}
                    </p>
                </template>
            </v-col>
        </v-row>
        <v-divider class="grey-ec" v-if="!hideDivider" />
    </v-sheet>
</template>

<script>
export default {
    props: {
        term: String,
        message: String,
        required: Boolean,
        hideDivider: Boolean,
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .vertical-table__contents {
        max-width: calc(100% - 170px);
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
